var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showRewardModal
    ? _c(
        "div",
        {
          staticClass: "reward-modal",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.closeRewardModal.apply(null, arguments)
            },
          },
        },
        [
          _vm.showFireworks
            ? _c(
                "div",
                { staticClass: "fireworks-container" },
                _vm._l(10, function (n) {
                  return _c("div", { key: n, staticClass: "firework-rocket" })
                }),
                0
              )
            : _vm._e(),
          _c("div", { staticClass: "reward-modal-content" }, [
            _c(
              "div",
              { staticClass: "reward-modal-header gradient_background_color" },
              [
                _c("div", { staticClass: "header-decoration" }),
                _c("h3", [_vm._v(_vm._s(_vm.$t("winning_award_text")))]),
                _c(
                  "span",
                  {
                    staticClass: "close-btn",
                    on: { click: _vm.closeRewardModal },
                  },
                  [_vm._v("×")]
                ),
              ]
            ),
            _c("div", { staticClass: "reward-modal-body" }, [
              _c("div", { staticClass: "reward-image-container" }, [
                _c("div", { staticClass: "reward-image-wrapper" }, [
                  _c("img", {
                    attrs: { src: _vm.reward.image, alt: _vm.reward.describe },
                  }),
                  _c("div", { staticClass: "reward-glow" }),
                ]),
              ]),
              _c("div", { staticClass: "reward-info" }, [
                _c("p", { staticClass: "reward-title" }, [
                  _vm._v(_vm._s(_vm.reward.describe)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "reward-modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "confirm-btn gradient_background_color",
                  on: { click: _vm.closeRewardModal },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("confirm_text")))])]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }